import React from 'react';

import { Checkbox, createStyles, FormControlLabel, Grid, Icon, IconButton, makeStyles, Tooltip } from '@material-ui/core';

import { EditAction } from '../../../../../shared/enum/EditAction';
import { ClientContext } from '../../../ClientContext';
import { OrganogramModel } from '../../../../../Models/OrganogramModel';

export interface ICutoutOrganogramItemProps {
    item: OrganogramModel,
    level: number,
    isParent: boolean,
    expanded: boolean,
}

const useStyles = makeStyles(() => createStyles({
    organogramRow: {
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
    },
}));

export function CutoutOrganogramItem({ item, level, isParent, expanded }: ICutoutOrganogramItemProps) {
    const classes = useStyles();
    const clientContext = React.useContext(ClientContext);

    const handleSelect = (checked: boolean) => {
        const editAction = checked ? EditAction.SELECTED : EditAction.NONE;

        const list = JSON.parse(JSON.stringify(clientContext.cutoutOrganogram));
        let currentOrganogram: OrganogramModel[] = item ? [item] : [];
        let selectList: OrganogramModel[] = item ? [item] : [];

        const index = list.findIndex((o: OrganogramModel) => o.id === item.id);
        list[index].editAction = editAction;

        while (currentOrganogram.length > 0) {
            let filter: OrganogramModel[] = [];
            currentOrganogram.forEach(organogram => {
                const found: OrganogramModel[] = list.filter((o: OrganogramModel) => o.parentId === organogram.id);
                filter = filter.concat(found);
            });

            selectList = selectList.concat(filter);
            currentOrganogram = filter;
        }

        selectList.forEach(organogram => {
            const index = list.findIndex((o: OrganogramModel) => o.id === organogram.id);

            if (index > -1)
                list[index].editAction = editAction;
        });
        
        const listOrganogram = clientContext.cutoutOrganogram;
        const parentOrganogram = listOrganogram.reduce<Record<number, OrganogramModel>>((acc, org) => {
            acc[org.id] = org;
            return acc;
            }, {});
    
        let current = parentOrganogram[item.id];
        while (current) {
            const index = list.findIndex((o: OrganogramModel) => o.id === current.id);
            list[index].editAction = editAction;
            current = parentOrganogram[current.parentId ?? 0];
        }

        clientContext.setCutoutOrganogram(list);
    };

    return (
        <Grid item xs={12} className={classes.organogramRow}>
            <Grid
                container
                key={`${item.id}-${level}`}
                justify="space-between"
                alignItems="center">

                <Grid item xs={1}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={item.editAction == EditAction.SELECTED}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    event.stopPropagation();
                                    handleSelect(event.target.checked);
                                }}
                                name="Checked"
                                color="primary" />
                        }
                        label={undefined} />
                </Grid>

                <Grid item xs={11} style={{ paddingLeft: `${(level - 1) * 15}px` }}>
                    {isParent && (
                        <>
                            <Tooltip title="Expandir">
                                <IconButton
                                    size="small">
                                    <Icon className={'material-icons-round'}>{expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}</Icon>
                                </IconButton>
                            </Tooltip>
                            {item.description}
                        </>
                    )}
                    {!isParent && (<div style={{ paddingLeft: '28px' }}>{item.description}</div>)}
                </Grid>
            </Grid>
        </Grid>
    );
}